<template>
  <div>
    <v-flex v-if="terc.length === 6" xs12 pr-2>
      <v-autocomplete
        clearable
        v-model="model[field].$value"
        item-text="name"
        item-value="symbol"
        :items="cities"
        :errorMessages="this.model[this.field].$error"
        @focus="focus"
        @blur="blur"
        @change="changeCity"
      >
        <div slot="label">{{ fieldModel.$schema.title }}<span v-if="fieldModel.$schema.fieldRequired"> *</span></div>
      </v-autocomplete>
    </v-flex>
  </div>
</template>

<script>
import axios from 'axios';

import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Input na SIMC-a
// @group Components/Forms
export default {
  mixins: [notificationsMixin],
  props: {
    // Schema
    model: {
      type: Object,
      required: true
    },
    // Nazwa pola z SIMC-em
    field: {
      type: String,
      required: false,
      default: 'simc'
    },
    // Wartość TERC-a
    terc: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      cities: []
    };
  },
  methods: {
    // @vuese
    // Pobiera listę miejscowości
    getSIMCList() {
      if (this.terc.length === 6) {
        axios
          .get(`${process.env.VUE_APP_TERYT_API_URL}/simc/?terc=${this.terc}`)
          .then(res => {
            this.cities = res.data.list;
            if (this.cities.length === 1) {
              this.changeCity(this.cities[0].symbol);
            }
          })
          .catch(error => this.notifyError('Nie udało się pobrać listy miejscowości'));
      } else {
        this.cleanSIMC();
      }
    },
    // @vuese
    // Wyczyszczenie formularza
    cleanSIMC() {
      this.cities = [];
      this.model.$setData({
        city: '',
        [this.field]: ''
      });
    },
    // @vuese
    // Zapisanie w schema i wyczyszczenie odpowiednich pól po wybraniu miejscowości
    changeCity(val) {
      this.model.$setData({
        city: val ? this.cities.find(item => item.symbol === val).name : '',
        [this.field]: val ? val : ''
      });
    },
    focus() {
      this.model[this.field].$hasFocus = true;
    },
    blur() {
      this.model[this.field].$hasFocus = false;
    }
  },
  watch: {
    terc(newValue) {
      this.cleanSIMC();
      this.getSIMCList();
    }
  },
  computed: {
    fieldModel() {
      return this.model[this.field];
    }
  },
  beforeMount() {
    this.getSIMCList();
  }
};
</script>
